// import {PWMAT_RESOURCE} from './consts'

export const Seminar = [{
  name:'Issue 1',
  url:'https://www.bilibili.com/video/BV1zd4y1A7GC/?spm_id_from=333.999.0.0',
  file_name:'Nanostructured Large System Material Calculation'
},
{
  name:'Issue 2',
  url:'https://www.bilibili.com/video/BV1zd4y1A7GC?p=2',
  file_name:'Publishing high-impact papers using the fixed potential method'
},
{
  name:'Issue 3',
  url:'https://www.bilibili.com/video/BV1zd4y1A7GC?p=3',
  file_name:'Publish high-impact papers using rt-TDDFT'
},
]
